import Nullstack from 'nullstack';
export default function IconBarcodeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-barcode-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 7v-1c0 -.552 .224 -1.052 .586 -1.414"
  }), "   ", Nullstack.element("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h2"
  }), "   ", Nullstack.element("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v1"
  }), "   ", Nullstack.element("path", {
    d: "M16 20h2c.551 0 1.05 -.223 1.412 -.584"
  }), "   ", Nullstack.element("path", {
    d: "M5 11h1v2h-1z"
  }), "   ", Nullstack.element("path", {
    d: "M10 11v2"
  }), "   ", Nullstack.element("path", {
    d: "M15 11v.01"
  }), "   ", Nullstack.element("path", {
    d: "M19 11v2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}